(function () {
    function isRailsUJSLoaded() {
        var _a;
        return window.Rails ||
            ((_a = window.jQuery) === null || _a === void 0 ? void 0 : _a.rails);
    }
    function swapAttr(element, dataAttr, upAttr) {
        if (element.hasAttribute(dataAttr)) {
            let dataValue = element.getAttribute(dataAttr);
            up.element.setMissingAttr(element, upAttr, dataValue);
            element.removeAttribute(dataAttr);
        }
    }
    function defineMacro(elementSelector, relevantFn) {
        up.macro(`:is([data-confirm], [data-method]):is(${elementSelector})`, function (element) {
            if (isRailsUJSLoaded() && relevantFn(element)) {
                swapAttr(element, 'data-confirm', 'up-confirm');
                swapAttr(element, 'data-method', 'up-method');
            }
        });
    }
    defineMacro('a[href], [up-href]', (el) => up.link.isFollowable(el));
    defineMacro('form, input[type=submit], button[type=submit], button:not([type])', (el) => up.form.isSubmittable(up.form.get(el)));
})();
